module.exports = __webpack_public_path__ + "img/water-treatment-plant.5bd5d66d.svg";